<accredible-base-header *transloco="let t; lang: 'en|static' read: 'abemcertified_abem_org.header'">
  <div navigationSection>
    <sl-header-menu *ngIf="extraLinksLoaded"
      [extraDynamicMenuItems]="extraHeaderLinks">
    </sl-header-menu>
  </div>
</accredible-base-header>
